import styled from 'styled-components';

const LinksWrapper = styled.div`
  margin: 32px 0 8px 0;
`;

export { LinksWrapper };
